import { render, staticRenderFns } from "./meetFileDialog.vue?vue&type=template&id=2fbba890&scoped=true"
import script from "./meetFileDialog.vue?vue&type=script&lang=js"
export * from "./meetFileDialog.vue?vue&type=script&lang=js"
import style0 from "./meetFileDialog.vue?vue&type=style&index=0&id=2fbba890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbba890",
  null
  
)

export default component.exports